/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/
const plMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 Wszelkie prawa zastrzeżone.',

  /* 02.Logowanie użytkownika, wylogowanie, rejestracja */
  'user.login-title': 'Logowanie',
  'user.register': 'Rejestracja',
  'user.forgot-password': 'Zapomniałeś hasła',
  'user.email': 'E-mail',
  'user.newpassword': 'Nowe hasło',
  'user.currentpassword': 'Obecne hasło',
  'user.newpasswordagain': 'Powtórz nowe hasło',
  'user.password': 'Hasło',
  'user.forgot-password-question': 'Zapomniałeś hasła?',
  'user.fullname': 'Imię i nazwisko',
  'user.firstname': 'Imię',
  'user.lastname': 'Nazwisko',
  'user.login-button': 'ZALOGUJ SIĘ',
  'user.register-button': 'ZAREJESTRUJ',
  'user.reset-password-button': 'RESETUJ',
  'user.buy': 'KUP',
  'user.username': 'Nazwa użytkownika',

  /* 03.Menu */
  'menu.app': 'Strona główna',
  'menu.online': 'Online',
  'menu.offline': 'Offline',
  'menu.default': 'Domyślny',
  'menu.analytics': 'Analityka',
  'menu.ecommerce': 'E-commerce',
  'menu.content': 'Treść',
  'menu.pages': 'Strony',
  'menu.data-list': 'Lista danych',
  'menu.thumb-list': 'Lista miniatur',
  'menu.image-list': 'Lista obrazów',
  'menu.details': 'Szczegóły',
  'menu.search': 'Szukaj',
  'menu.login': 'Logowanie',
  'menu.register': 'Rejestracja',
  'menu.forgot-password': 'Zapomniałeś hasła',
  'menu.error': 'Błąd',
  'menu.applications': 'Aplikacje',
  'menu.todo': 'Lista zadań',
  'menu.survey': 'Ankieta',
  'menu.chat': 'Czat',
  'menu.ui': 'Interfejs',
  'menu.edit': 'Edytuj',
  'menu.alerts': 'Alerty',
  'menu.badges': 'Odznaki',
  'menu.buttons': 'Przyciski',
  'menu.cards': 'Karty',
  'menu.carousel': 'Karuzela',
  'menu.charts': 'Wykresy',
  'menu.collapse': 'Zwijanie',
  'menu.dropdowns': 'Listy rozwijane',
  'menu.editors': 'Edytory',
  'menu.form-layouts': 'Układy formularzy',
  'menu.form-components': 'Komponenty formularzy',
  'menu.form-validations': 'Walidacje formularzy',
  'menu.icons': 'Ikony',
  'menu.input-groups': 'Grupy wejściowe',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Nawigacja',
  'menu.popover-tooltip': 'Popover i Tooltip',
  'menu.sortable': 'Sortowalne',
  'menu.tables': 'Tabele',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Ukryte podrzędne',
  'menu.hidden': 'Ukryte',
  'menu.visible': 'Widoczne',
  'menu.maps': 'Mapy',
  'menu.landingpage': 'Strona docelowa',
  'menu.multipage-home': 'Strona wielostronicowa',
  'menu.singlepage-home': 'Strona jednostronicowa',
  'menu.about': 'O nas',
  'menu.auth-login': 'Logowanie',
  'menu.auth-register': 'Rejestracja',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Szczegóły bloga',
  'menu.careers': 'Kariera',
  'menu.confirmation': 'Potwierdzenie',
  'menu.contact': 'Kontakt',
  'menu.docs': 'Dokumentacja',
  'menu.features': 'Funkcje',
  'menu.prices': 'Ceny',
  'menu.videos': 'Filmy',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Faktura',
  'menu.blank-page': 'Wkrótce dostępne...',
  'menu.types': 'Typy menu',
  'menu.levels': 'Poziomy menu',
  'menu.third-level-1': 'Trzeci poziom 1',
  'menu.third-level-2': 'Trzeci poziom 2',
  'menu.third-level-3': 'Trzeci poziom 3',

  /* 04.Dashboards */
  'dashboards.update': 'Aktualizuj',
  'dashboards.save': 'Zapisz',
  'dashboards.saveSchedule': 'Zapisz harmonogram',
  'dashboards.name': 'Nazwa',
  'dashboards.button': 'Przycisk',
  'dashboards.visits': 'Wizyty',
  'dashboards.checkAvailability': 'Sprawdź dostępność lub ceny',
  'dashboards.details': 'Szczegóły',
  'dashboards.pending-orders': 'Oczekujące zamówienia',
  'dashboards.completed-orders': 'Zrealizowane zamówienia',
  'dashboards.refund-requests': 'Prośby o zwrot',
  'dashboards.new-comments': 'Nowe komentarze',
  'dashboards.sales': 'Sprzedaż',
  'dashboards.orders': 'Zamówienia',
  'dashboards.refunds': 'Zwroty',
  'dashboards.recent-orders': 'Ostatnie zamówienia',
  'dashboards.product-categories': 'Kategorie produktów',
  'dashboards.cakes': 'Ciasta',
  'dashboards.tickets': 'Zgłoszenia',
  'dashboards.calendar': 'Kalendarz',
  'dashboards.best-sellers': 'Bestsellery',
  'dashboards.per-session': 'Na sesję',
  'dashboards.profile-status': 'Status profilu',
  'dashboards.payment-status': 'Status płatności',
  'dashboards.work-progress': 'Postęp prac',
  'dashboards.tasks-completed': 'Ukończone zadania',
  'dashboards.payments-done': 'Wykonane płatności',
  'dashboards.order-stock': 'Zamówienia - magazyn',
  'dashboards.categories': 'Kategorie',
  'dashboards.quick-post': 'Szybki post',
  'dashboards.title': 'Tytuł',
  'dashboards.content': 'Treść',
  'dashboards.ticket-count': 'Liczba zgłoszeń',
  'dashboards.commonticketsubmission': 'Popularne zgłoszenia',
  'dashboards.category': 'Kategoria',

  'dashboards.save-and-publish': 'Zapisz i opublikuj',
  'dashboards.top-viewed-posts': 'Najczęściej oglądane posty',
  'dashboards.posts': 'Posty',
  'dashboards.pending-for-publish': 'Oczekuje na publikację',
  'dashboards.users': 'Użytkownicy',
  'dashboards.on-approval-process': 'W procesie zatwierdzania',
  'dashboards.alerts': 'Alerty',
  'dashboards.waiting-for-notice': 'Oczekiwanie na powiadomienie',
  'dashboards.files': 'Pliki',
  'dashboards.pending-for-print': 'Oczekuje na wydruk',
  'dashboards.logs': 'Logi',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIA TKWI W SZCZEGÓŁACH',
  'dashboards.yes-it-is-indeed': 'Tak, dokładnie!',
  'dashboards.advanced-search': 'Wyszukiwanie zaawansowane',
  'dashboards.toppings': 'Dodatki',
  'dashboards.type': 'Typ',
  'dashboards.keyword': 'Słowo kluczowe',
  'dashboards.search': 'Szukaj',
  'dashboards.top-rated-items': 'Najwyżej oceniane elementy',
  'dashboards.country': 'Kraj',
  'dashboards.webVisitors': 'Odwiedzający stronę',
  'dashboards.avatarClicks': 'Kliknięcia avatara',
  'dashboards.wordCloud': 'Chmura słów',
  'dashboards.topic': 'Temat',
  'dashboards.roomsAvailability': 'Pokoje i dostępność',
  'dashboards.startChat': 'Rozpocznij czat',
  'dashboards.restaurantsBars': 'Restauracje i bary',
  'dashboards.groupBooking': 'Rezerwacja grupowa',
  'dashboards.promotions': 'Promocje',
  'dashboards.weedingevents': 'Wesela i wydarzenia',
  'dashboards.lostsomething': 'Zgubiono coś',
  'dashboards.producttext': 'Tekst produktu',
  'dashboards.bookingroomnew': 'Nowa rezerwacja pokoju',
  'dashboards.email': 'Email',
  'dashboards.phone': 'Telefon',
  'dashboards.zipcode': 'Kod pocztowy',
  'dashboards.marketingconsent': 'Zgoda marketingowa',
  'dashboards.additionalinfo': 'Dodatkowe informacje',
  'dashboards.viewallcontacts': 'Zobacz wszystkie kontakty',
  'dashboards.current': 'Aktualne',
  'dashboards.last7days': 'Ostatnie 7 dni',
  'dashboards.last30days': 'Ostatnie 30 dni',
  'dashboards.thisweek': 'Ten tydzień',
  'dashboards.thismonth': 'Ten miesiąc',
  'dashboards.previousmonth': 'Poprzedni miesiąc',
  'dashboards.yeartodate': 'Od początku roku',
  'dashboards.lastyear': 'Ostatni rok',
  'dashboards.all': 'Wszystkie',
  'dashboards.standardOccupancy': 'Standardowe obłożenie',
  'dashboards.max-occupancy': 'Maksymalne obłożenie',
  'dashboards.numberOfThisType': 'Liczba tego typu',
  'dashboards.displayOrder': 'Kolejność wyświetlania',
  'dashboards.provider': 'Dostawca',
  'dashboards.edit': 'Edytuj',
  'dashboards.delete': 'Usuń',
  'dashboards.addImages': 'Dodaj obrazy',
  'dashboards.near': 'W pobliżu',
  'dashboards.calling_party': 'Osoba dzwoniąca',
  'dashboards.called_party': 'Osoba odbierająca',
  'dashboards.lastdial': 'Ostatnio wybierany numer',
  'dashboards.imagelink': 'Link do obrazu',
  'dashboards.browsegallery': 'Przeglądaj galerię',
  'dashboards.changelog': 'Dziennik zmian',
  'dashboards.externalresources': 'Zewnętrzne zasoby',
  'dashboards.webpage': 'Strona internetowa',
  'dashboards.web-pages': 'Strony internetowe',
  'dashboards.published': 'Opublikowano',
  'dashboards.adddocument': 'Dodaj dokument',
  'dashboards.ready-to-publish': 'Gotowe do publikacji',
  'dashboards.draft': 'Wersja robocza',
  'dashboards.order-by': 'Sortuj według',
  'dashboards.add-faq': 'Dodaj FAQ',
  'dashboards.collections': 'Kolekcje',
  'dashboards.items': 'Elementy',
  'dashboards.rooms-availability': 'Pokoje i dostępność',
  'dashboards.events-wedding-venues': 'Wydarzenia i sale weselne',
  'dashboards.long-stay-enquiry': 'Zapytanie o długi pobyt',
  'dashboards.reservation-confirmation-request':
    'Prośba o potwierdzenie rezerwacji',
  'dashboards.modify-cancel-booking': 'Zmień lub anuluj rezerwację',
  'dashboards.left-something-behind': 'Pozostawiono coś',
  'dashboards.invoice-copy': 'Kopia faktury/paragonu',
  'dashboards.sync': 'Synchronizuj',
  'dashboards.syncNow': 'Synchronizuj teraz',
  'dashboards.add-web-page': 'Dodaj stronę internetową',

  /* Chat */
  'chat.messages': 'Wiadomości',
  'chat.contacts': 'Kontakty',
  'chat.saysomething': 'Napisz coś..',

  /* Survey */
  'survey.delete': 'Usuń',
  'survey.edit': 'Edytuj',
  'survey.add-new': 'DODAJ NOWY',
  'survey.add-new-title': 'Dodaj nową ankietę',
  'survey.title': 'Tytuł',
  'survey.category': 'Kategoria',
  'survey.label': 'Etykieta',
  'survey.status': 'Status',
  'survey.cancel': 'Anuluj',
  'survey.submit': 'Wyślij',
  'survey.another-action': 'Inna akcja',
  'survey.display-options': 'Opcje wyświetlania',
  'survey.orderby': 'Sortuj według : ',
  'survey.all-surveys': 'Wszystkie ankiety',
  'survey.completed-surveys': 'Ukończone ankiety',
  'survey.categories': 'Kategorie',
  'survey.active-surveys': 'Aktywne ankiety',
  'survey.labels': 'Etykiety',

  /* Todo */
  'todo.add-new': 'DODAJ NOWE',
  'todo.add-new-title': 'Dodaj nowe zadanie',
  'todo.title': 'Tytuł',
  'todo.detail': 'Szczegóły',
  'todo.category': 'Kategoria',
  'todo.label': 'Etykieta',
  'todo.status': 'Status',
  'todo.cancel': 'Anuluj',
  'todo.submit': 'Wyślij',
  'todo.action': 'Akcja',
  'todo.another-action': 'Inna akcja',
  'todo.display-options': 'Opcje wyświetlania',
  'todo.orderby': 'Sortuj według : ',
  'todo.all-tasks': 'Wszystkie zadania',
  'todo.pending-tasks': 'Oczekujące zadania',
  'todo.completed-tasks': 'Ukończone zadania',
  'todo.categories': 'Kategorie',
  'todo.labels': 'Etykiety',

  /* 07.01.Alerts */
  'alert.rounded': 'Zaokrąglony alert',
  'alert.react-notifications': 'Powiadomienia React',
  'alert.outline': 'Obramowanie',
  'alert.primary': 'Podstawowy',
  'alert.secondary': 'Drugorzędny',
  'alert.info': 'Informacja',
  'alert.success': 'Sukces',
  'alert.warning': 'Ostrzeżenie',
  'alert.error': 'Błąd',
  'alert.filled': 'Wypełniony',
  'alert.primary-text': 'To jest podstawowy alert — sprawdź to!',
  'alert.secondary-text': 'To jest drugorzędny alert — sprawdź to!',
  'alert.success-text': 'To jest alert sukcesu — sprawdź to!',
  'alert.danger-text': 'To jest alert zagrożenia — sprawdź to!',
  'alert.warning-text': 'To jest alert ostrzegawczy — sprawdź to!',
  'alert.info-text': 'To jest alert informacyjny — sprawdź to!',
  'alert.light-text': 'To jest jasny alert — sprawdź to!',
  'alert.dark-text': 'To jest ciemny alert — sprawdź to!',
  'alert.default': 'Domyślny alert',
  'alert.dismissing': 'Zamykany alert',
  'alert.dismissing-text':
    'Święte guacamole! Powinieneś sprawdzić niektóre pola poniżej.',
  'alert.dismissing-without-animate-text':
    'Jestem alertem i mogę zostać zamknięty bez animacji!',

  /* 07.02.Badges */
  'badge.sizes': 'Rozmiary',
  'badge.colors': 'Kolory',
  'badge.outline': 'Obramowanie',
  'badge.links': 'Linki',
  'badge.counter-badges': 'Odznaki licznika',
  'badge.bootstrap-default': 'Domyślny Bootstrap',
  'badge.primary': 'Podstawowy',
  'badge.secondary': 'Drugorzędny',
  'badge.success': 'Sukces',
  'badge.danger': 'Niebezpieczeństwo',
  'badge.warning': 'Ostrzeżenie',
  'badge.info': 'Informacja',
  'badge.light': 'Jasny',
  'badge.dark': 'Ciemny',

  /* 07.03.Buttons */
  'button.default': 'Domyślny Bootstrap',
  'button.colors': 'Kolory',
  'button.rounded': 'Zaokrąglony',
  'button.outline': 'Obramowanie',
  'button.states': 'Stany',
  'button.sizes': 'Rozmiary',
  'button.button-groups': 'Grupy przycisków',
  'button.large-button': 'Duży przycisk',
  'button.small-button': 'Mały przycisk',
  'button.extra-small-button': 'Bardzo mały przycisk',
  'button.block-button': 'Przycisk blokowy',
  'button.active': 'Aktywny',
  'button.disabled': 'Wyłączony',
  'button.basic': 'Podstawowy',
  'button.toolbar': 'Pasek narzędzi',
  'button.nesting': 'Zagnieżdżanie',
  'button.vertical-variation': 'Wersja pionowa',
  'button.checkbox-radio-button': 'Checkbox i przycisk radiowy',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Przycisk radiowy',
  'button.primary': 'Podstawowy',
  'button.secondary': 'Drugorzędny',
  'button.success': 'Sukces',
  'button.danger': 'Niebezpieczeństwo',
  'button.warning': 'Ostrzeżenie',
  'button.info': 'Informacja',
  'button.light': 'Jasny',
  'button.dark': 'Ciemny',
  'button.states-text':
    'Ten przycisk pokazuje spinner przez 2 sekundy i ikonę błędu przez 3 sekundy przed powrotem do normalnego stanu. Te stany można wywołać przez dodawanie i usuwanie klas.',
  'button.click-here': 'Kliknij tutaj',
  'button.states-text-alternate':
    'Ten przycisk pokazuje spinner przez 2 sekundy i ikonę błędu przez 3 sekundy przed powrotem do normalnego stanu. Te stany można wywołać przez dodawanie i usuwanie klas.',
  'button.primary-link': 'Podstawowy link',
  'button.link': 'Link',
  'button.primary-button': 'Podstawowy przycisk',
  'button.button': 'Przycisk',
  'button.left': 'Lewo',
  'button.middle': 'Środek',
  'button.right': 'Prawo',
  'button.dropdown': 'Menu rozwijane',
  'button.dropdown-link': 'Link rozwijany',

  /* 07.04.Cards */
  'cards.icon-card': 'Karta z ikoną',
  'cards.image-card': 'Karta obrazu',
  'cards.image-overlay-card': 'Karta z nakładką obrazu',
  'cards.image-card-list': 'Lista kart obrazów',
  'cards.tab-card': 'Karta zakładek',
  'cards.user-card': 'Karta użytkownika',

  /* 07.05.Carousel */
  'carousel.basic': 'Podstawowa karuzela',
  'carousel.single': 'Pojedyncza karuzela',
  'carousel.without-controls': 'Karuzela bez kontrolek',

  /* 07.06.Charts */
  'charts.line': 'Wykres liniowy',
  'charts.polar': 'Wykres polarny',
  'charts.area': 'Wykres obszarowy',
  'charts.scatter': 'Wykres punktowy',
  'charts.bar': 'Wykres słupkowy',
  'charts.radar': 'Wykres radarowy',
  'charts.pie': 'Wykres kołowy',
  'charts.doughnut': 'Wykres pierścieniowy',
  'charts.shadow': 'Cień',
  'charts.no-shadow': 'Bez cienia',

  /* 07.07.Collapse */
  'collapse.basic': 'Podstawowy',
  'collapse.toggle': 'Przełącznik',
  'collapse.accordion': 'Akordeon',
  'collapse.controlled': 'Kontrolowany',
  'collapse.uncontrolled': 'Niekontrolowany',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Podstawowy',
  'dropdowns.controlled': 'Kontrolowany',
  'dropdowns.uncontrolled': 'Niekontrolowany',
  'dropdowns.dropdown': 'Menu rozwijane',
  'dropdowns.header': 'Nagłówek',
  'dropdowns.action': 'Akcja',
  'dropdowns.another-action': 'Inna akcja',
  'dropdowns.right': 'Prawo',
  'dropdowns.left': 'Lewo',
  'dropdowns.drop-directions': 'Kierunki rozwijania',
  'dropdowns.dropright': 'Rozwijanie w prawo',
  'dropdowns.dropleft': 'Rozwijanie w lewo',
  'dropdowns.small-button': 'Mały przycisk',
  'dropdowns.large-button': 'Duży przycisk',
  'dropdowns.sizing': 'Rozmiary',
  'dropdowns.split-button': 'Rozdzielone menu rozwijane',
  'dropdowns.dropup': 'Rozwijanie do góry',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Podstawowy',
  'forms.email': 'E-mail',
  'forms.email-muted': 'Nigdy nie udostępnimy Twojego e-maila nikomu innemu.',
  'forms.password': 'Hasło',
  'forms.submit': 'Wyślij',
  'forms.horizontal': 'Poziomy',
  'forms.radios': 'Przyciski radiowe',
  'forms.first-radio': 'Pierwszy przycisk radiowy',
  'forms.second-radio': 'Drugi przycisk radiowy',
  'forms.third-radio-disabled': 'Trzeci wyłączony przycisk radiowy',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Zaloguj się',
  'forms.top-labels-over-line': 'Etykiety nad linią',
  'forms.tags': 'Tagi',
  'forms.date': 'Data',
  'forms.state': 'Stan',
  'forms.top-labels-in-input': 'Etykiety wewnątrz pola',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'HASŁO',
  'forms.tags-u': 'TAGI',
  'forms.date-u': 'DATA',
  'forms.state-u': 'STAN',
  'forms.grid': 'Siatka formularza',
  'forms.address': 'Adres',
  'forms.address2': 'Adres 2',
  'forms.city': 'Miasto',
  'forms.city-message': 'Wybierz miasto!',
  'forms.state-message': 'Wybierz stan!',
  'forms.zip': 'Kod pocztowy',
  'forms.signup': 'Zarejestruj się',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Walidacja Availity Reactstrap',
  'forms.validation-formik': 'Walidacja Formik',
  'forms.default': 'Domyślny',
  'forms.firstname': 'Imię',
  'forms.firstname-message': 'Wprowadź swoje imię!',
  'forms.lastname': 'Nazwisko',
  'forms.lastname-message': 'Wprowadź swoje nazwisko!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Niestandardowe pola',
  'form-components.checkboxes': 'Checkboxy',
  'form-components.radios': 'Przyciski radiowe',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Pojedynczy stan',
  'form-components.state-multiple': 'Wiele stanów',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Wybór daty',
  'form-components.date': 'Data',
  'form-components.date-range': 'Zakres dat',
  'form-components.date-with-time': 'Data z godziną',
  'form-components.embedded': 'Osadzony',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Upuść pliki tutaj',
  'form-components.tags': 'Tagi',
  'form-components.switch': 'Przełącznik',
  'form-components.primary': 'Podstawowy',
  'form-components.secondary': 'Drugorzędny',
  'form-components.primary-inverse': 'Odwrócony podstawowy',
  'form-components.secondary-inverse': 'Odwrócony drugorzędny',
  'form-components.slider': 'Suwak',
  'form-components.double-slider': 'Podwójny suwak',
  'form-components.single-slider': 'Pojedynczy suwak',
  'form-components.rating': 'Ocena',
  'form-components.interactive': 'Interaktywny',
  'form-components.readonly': 'Tylko do odczytu',
  'form-components.type-a-cake': 'Wpisz ciasto',
  'form-components.start': 'Start',
  'form-components.end': 'Koniec',
  'form-components.tables': 'Tabele',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Proste Ikony Liniowe',
  'icons.iconsmind': 'Ikony Iconsmind',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Podstawowe',
  'input-groups.sizing': 'Rozmiary',
  'input-groups.small': 'Mały',
  'input-groups.default': 'Domyślny',
  'input-groups.large': 'Duży',
  'input-groups.checkboxes-and-radios': 'Pola wyboru i przyciski radiowe',
  'input-groups.multiple-inputs': 'Wiele pól wejściowych',
  'input-groups.first-and-last-name': 'Imię i nazwisko',
  'input-groups.multiple-addons': 'Wiele dodatków',
  'input-groups.button-addons': 'Dodatki przycisków',
  'input-groups.button': 'Przycisk',
  'input-groups.buttons-with-dropdowns': 'Przyciski z menu rozwijanym',
  'input-groups.dropdown': 'Menu rozwijane',
  'input-groups.header': 'Nagłówek',
  'input-groups.action': 'Akcja',
  'input-groups.another-action': 'Inna akcja',
  'input-groups.custom-select': 'Niestandardowy wybór',
  'input-groups.options': 'Opcje',
  'input-groups.choose': 'Wybierz...',
  'input-groups.custom-file-input': 'Niestandardowe pole pliku',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Witaj, świecie!',
  'jumbotron.lead':
    'To jest prosty komponent typu hero, w stylu jumbotron, służący do zwrócenia większej uwagi na wyróżnione treści lub informacje.',
  'jumbotron.lead-detail':
    'Wykorzystuje klasy użytkowe dla typografii i odstępów, aby odpowiednio rozmieścić treść w większym kontenerze.',
  'jumbotron.learn-more': 'Dowiedz się więcej',

  /* 07.15.Modal */
  'modal.basic': 'Podstawowe',
  'modal.modal-title': 'Tytuł okna modalnego',
  'modal.launch-demo-modal': 'Uruchom przykładowe okno modalne',
  'modal.scrolling-long-content': 'Przewijana długa zawartość',
  'modal.backdrop': 'Tło',
  'modal.backdrop-value': 'Wartość tła',
  'modal.right-modal': 'Prawe okno modalne',
  'modal.launch-right-modal': 'Uruchom prawe okno modalne',
  'modal.nested-modal': 'Zagnieżdżone okno modalne',
  'modal.size': 'Rozmiar',
  'modal.launch-large-modal': 'Uruchom duże okno modalne',
  'modal.launch-small-modal': 'Uruchom małe okno modalne',

  /* 07.16.Navigation */
  'nav.basic': 'Podstawowa nawigacja',
  'nav.active': 'Aktywny',
  'nav.disabled': 'Wyłączony',
  'nav.disabled-link': 'Wyłączony link',
  'nav.link': 'Link',
  'nav.longer-link': 'Dłuższy link nawigacyjny',
  'nav.another-link': 'Inny link',
  'nav.right': 'Prawo',
  'nav.dropdown': 'Menu rozwijane',
  'nav.header': 'Nagłówek',
  'nav.action': 'Akcja',
  'nav.another-action': 'Inna akcja',
  'nav.horizontal-alignment': 'Poziome wyrównanie nawigacji',
  'nav.vertical-alignment': 'Pionowe wyrównanie nawigacji',
  'nav.pills': 'Zakładki',
  'nav.fill-justify': 'Wypełnienie i wyjustowanie',
  'nav.pills-dropdowns': 'Zakładki z menu rozwijanym',
  'nav.pagination-basic': 'Podstawowa paginacja',
  'nav.pagination-sizing': 'Rozmiar paginacji',
  'nav.large': 'Duży',
  'nav.small': 'Mały',
  'nav.center': 'Wyśrodkuj',
  'nav.pagination-alignment': 'Wyrównanie paginacji',
  'nav.breadcrumb-basic': 'Podstawowa ścieżka nawigacyjna',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Wyskakujące okno',
  'popover-tooltip.tooltip': 'Podpowiedź',

  /* 07.18.Sortable */
  'sortable.columns': 'Sortowanie kolumn',
  'sortable.basic': 'Podstawowe',
  'sortable.handles': 'Uchwyty',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Tabele Bootstrap',
  'table.bootstrap-basic': 'Podstawowa tabela',
  'table.bootstrap-striped': 'Paskowane wiersze',
  'table.bootstrap-bordered': 'Tabela z obramowaniem',
  'table.bootstrap-borderless': 'Tabela bez obramowania',
  'table.bootstrap-hoverable': 'Wiersze z efektem hover',
  'table.bootstrap-responsive': 'Responsywna tabela',
  'table.react-tables': 'Tabele React',
  'table.react-pagination': 'Paginacja',
  'table.react-scrollable': 'Przewijane',
  'table.react-advanced': 'Filtr, długość i przejście',

  /* Property Info */
  'property-info.allcustomers': 'Wszyscy klienci',
  'property-info.external-sources': 'Źródła zewnętrzne',
  'property-info.faq': 'FAQ',
  'property-info.documents': 'Dokumenty',
  'property-info.publish-ai': 'Publikuj AI',
  'property-info.pre-built-templates': 'Gotowe szablony',
  'property-info.room-types': 'Typy pokoi',
  'property-info.about-property': 'O obiekcie',
  'property-info.about-properties': 'O obiektach',
  'property-info.facilities-services': 'Udogodnienia i usługi',
  'property-info.property-facilities': 'Udogodnienia obiektu',
  'property-info.room-amenities': 'Wyposażenie pokoju',
  'property-info.property-contact': 'Kontakt z obiektem',
  'property-info.property-activities': 'Atrakcje obiektu',
  'property-info.property-location': 'Lokalizacja obiektu',
  'property-info.about-rooms': 'Pokoje',
  'property-info.about-sites': 'O lokalizacjach',
  'property-info.special-emergencies': 'Sytuacje awaryjne',
  'property-info.gallery': 'Galeria',
  'property-info.policies': 'Zasady',
  'property-info.nearby': 'W pobliżu',
  'property-info.transport': 'Transport',
  'property-info.location': 'Lokalizacja',
  'property-info.about-rhproperty': 'O domu opieki',
  'property-info.related-topics': 'Powiązane tematy',
  'property-info.assistant-options': 'Wiadomość powitalna',
  'property-info.restaurant-assistant-information': 'Informacje o restauracji',
  'property-info.restaurant-assistant-options': 'Wiadomość powitalna',
  'property-info.channel-messages': 'Wiadomości kanału',
  'property-info.icon.gallery': 'Biblioteka ikon',
  'property-info.copilot': 'Copilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Informacje o domu',
  'property-info.loction': 'Lokalizacje',
  'property-info.rooms-and-images': 'Pokoje i zdjęcia',
  'property-info.trainig-data': 'Dane treningowe AI',
  'property-info.publishMonitor': 'Publikuj i monitoruj',
  'property-info.webWidget': 'Widget internetowy',
  'property-info.media': 'Media',
  'property-info.flows': 'Przepływy',
  'property-info.add-your-own': 'Dodaj własne',
  'property-info-utility-miscellaneous': 'Różne',
  'property-info-utility-payment': 'Płatności',
  'property-info-utility-broadband': 'Internet szerokopasmowy',
  'property-info-utility-emergency': 'Nagły wypadek',
  'property-info-utility-mobile': 'Telefon komórkowy',
  'property-info-utility-moving': 'Przeprowadzka',

  /** Rate & Promo */
  'rate-promo.rate-plans': 'Plany cenowe',
  'rate-promo.rate-plan-addons': 'Dodatki',
  'rate-promo.rate-plan-promos': 'Promocje',

  'title.property-information': 'Informacje o obiekcie',

  'property.message': 'Wiadomość',
  'property.example': 'Przykład',
  'property.link': 'Linki',
  'property.image-carousel': 'Karuzela obrazów',
  'property.Title': 'Tytuł',
  'property.SubTitle': 'Podtytuł',

  'property.add-invoke-api': 'Wywołaj API',
  'property.add-message-button': 'Dodaj wiadomości',
  'property.add-img-button': 'Dodaj obrazy',
  'property.add-link-button': 'Dodaj link',

  'property.add-herocard-button': 'Dodaj kartę hero',
  'property.add-api-button': 'Dodaj przyciski',
  'menu.settings': 'Ustawienia',
  'menu.workflows': 'Przepływy pracy',
  'menu.product_services': 'Produkty i Usługi',
  'menu.product_recommander': 'Rekomendacje Produktów',
  'menu.digital_guide_book': 'Cyfrowy Przewodnik',
  'menu.welcome_message': 'Wiadomość Powitalna',
  'menu.about-property': 'O Obiekcie',
  'menu.property-facilities': 'Udogodnienia Obiektu',
  'menu.room-amenities': 'Udogodnienia Pokoi',
  'menu.property-contact': 'Kontakt z Obiektem',
  'menu.about-rooms': 'Pokoje',
  'menu.special-emergencies': 'Sytuacje Awaryjne',
  'menu.show-filter': 'Filtry',
  'menu.new': 'Nowy',
  'menu.channel': 'Kanały',
  'menu.application': 'Aplikacje',

  'dashboards.send': 'Wyślij',
  'dashboards.hello': 'Witaj',
  'dashboards.notificationsAllowed': 'Powiadomienia Dozwolone',
  'dashboards.allowNotifications': 'Zezwól na Powiadomienia',
  'dashboards.views': 'Wyświetlenia',
  'dashboards.bookingURL': 'URL Rezerwacji',
  'dashboards.searchTags': 'Tagi Wyszukiwania',
  'dashboards.searchCategoryTags': 'Tagi Kategorii Wyszukiwania',
  'dashboards.bedroom': 'Sypialnia',
  'dashboards.addBedroom': 'Dodaj Sypialnię',
  'dashboards.frequency': 'Częstotliwość',
  'dashboards.includeSubpages': 'Uwzględnij Podstrony',
  'dashboards.enableFaqs': 'Włącz FAQ',
  'dashboards.faqsDescription':
    'Włączenie FAQ umożliwia dodawanie pytań, podczas gdy system automatycznie wyodrębnia odpowiedzi z zawartości strony internetowej, aby utworzyć kompletne FAQ',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Usuń Dokument',
  'dashboards.confirmDelete': 'Czy na pewno chcesz usunąć?',
  'dashboards.addItem': 'Dodaj Element',
  'dashboards.addFirstWebPage': 'Dodaj Swoją Pierwszą Stronę Internetową',

  'dashboards.popular-compendium': 'Popularne Pozycje Menu Kompendium',
  'dashboards.wordcloudofcompendium': 'Chmura Słów Pozycji Menu Kompendium',
  'dashboards.wordcloudonthings':
    'Chmura Słów Dotyczących Pytań Odwiedzających Stronę i Pozycji Menu',
  'dashboards.common-asked': 'Najczęściej Zadawane Pytania',

  'dashboards.website-visitor-asking': 'O co pytają odwiedzający stronę',
  'dashboards.visit-country': 'Wizyty na Stronie według Kraju',
  'dashboards.visit-traffic': 'Kraj Ruchu na Stronie',
  'dashboards.rooms-product': 'Pokoje i Produkty',
  'dashboards.popular-room-product': 'Popularne pokoje i produkty',

  'dashboards.messenger-stats': 'Popularne Pozycje Menu',
  'dashboards.messenger-stats-topic-view': 'Statystyki Wyświetleń Pozycji Menu',
  'dashboards.messenger-stats-visits': 'Wyświetlenia Pozycji Menu',
  'dashboards.opening-menu-items':
    'Liczba Odwiedzających Otwierających Pozycje Menu',

  'dashboards.number-totalavatarclick': 'Łączna Liczba Kliknięć Awatara',

  'dashboards.clicks': 'Kliknięcia',
  'dashboards.leads': 'Leady',
  'dashboards.hours': 'Godziny',
  'dashboards.minutes': 'Minuty',
  'dashboards.connect': 'Połącz',
  'dashboards.ai-chatbot': 'Chatbot AI',
  'dashboards.compendium': 'Kompendium',
  'dashboards.compendium-digital-usage': 'Użycie Cyfrowego Kompendium',
  'dashboards.compendium-unique-visits': 'Skany/Kliknięcia kodów QR',
  'dashboards.compendium-opening-menu-items':
    'Liczba wyświetlonych pozycji menu',
  'dashboards.compendium-total-digital-clicks':
    'Łączna Liczba Wyświetleń Pozycji Menu',
  'dashboards.compendium-total-qr-code':
    'Łączna Liczba Skanów/Kliknięć kodów QR',
  'dashboards.compendium-avg-menu-items':
    'Średnia Liczba Wyświetleń Menu na Skan',
  'dashboards.top-clicked-urls': 'Najczęściej Klikane URL',
  'dashboards.top-clicked-urls-description': 'Analityka Kliknięć URL',
  'dashboards.urls': 'URL',

  'dashboards.externalDeleteMessage':
    'Ten dokument został wygenerowany z zewnętrznych źródeł. Jeśli nie chcesz, aby został ponownie utworzony, upewnij się, że powiązany harmonogram synchronizacji również został usunięty.',
  'dashboards.deleteAndGoToExternalSources':
    'Usuń i Przejdź do Źródeł Zewnętrznych',

  'dashboards.sound': 'Dźwięk',
  'dashboards.browser': 'Przeglądarka',
  'dashboards.mac': 'Mac',
  'dashboards.windows': 'Windows',

  'property.delete': 'Usuń',

  'menu.userroles': 'Użytkownicy i Role',
  'menu.members': 'Członkowie',
  'menu.guest-pass': 'Punkty Przepustek Gości',
  'menu.ratebookings': 'Stawki i Rezerwacje',

  'dashboards.engagement-time': 'Czas Zaangażowania Cyfrowego Asystenta',
  'dashboards.conversations-minutes':
    'Łączna Liczba Minut Rozmów i Rozmów Nocnych (19:00–7:00)',

  'dashboards.visitor-questions': 'Pytania Odwiedzających',
  'dashboards.recent-queries': 'Ostatnie Zapytania',
  'dashboards.visitor-saying': 'O czym rozmawiają Twoi rozmówcy',
  'dashboards.contacts-prechatform-leavemessage':
    'Zapisane Kontakty z Formularza Przed Czatem i Wiadomości',

  'menu.dashboards': 'Statystyki',
  'menu.ari': 'Dostępność i Stawki',
  'menu.conversations': 'Rozmowy',
  'menu.conversations.unified-inbox': 'Zunifikowana Skrzynka Odbiorcza',
  'menu.conversations.active': 'Wsparcie Agenta',
  'menu.conversations.archives': 'Archiwa',
  'menu.conversations.missed-responses': 'Pominięte Odpowiedzi',
  'menu.conversations.ticket': 'Zgłoszenia',
  'menu.conversations.reply-templates': 'Szablony Odpowiedzi',

  'menu.bookings': 'Rezerwacje',
  'menu.tickets': 'Leady i Zgłoszenia',
  'menu.propinfo': 'Baza Wiedzy',
  'menu.rate-promos': 'Stawki i Promocje',
  'menu.finance': 'Finanse',
  'menu.integration': 'Integracje',
  'menu.admin': 'Administracja i Bezpieczeństwo',
  'menu.favourites': 'Ulubione',
  'menu.recommender': 'Przepływy Rozmów',
  'menu.assistant-setup': 'Konfiguracja Asystenta',
  'menu.admin-insights': 'Statystyki Administratora',
  'menu.super-admin': 'Super Administrator',
  'menu.groups': 'Grupy',
  'menu.properties': 'Obiekty',
  'menu.service-provider': 'Dostawcy Usług',
  'menu.spaces': 'Przestrzenie',
  'menu.content-manager': 'Menedżer Treści',
  'menu.events-calendar': 'Kalendarz Wydarzeń',
  'menu.appearance-settings': 'Wygląd i Ustawienia',
  'menu.help': 'Pomoc',
  'menu.availability': 'Dostępność',
  'menu.myAccounts': 'Moje Konta',

  'menu.guest-messaging': 'Komunikacja z Gośćmi',
  'guest-messaging.settings': 'Ustawienia',
  'guest-messaging.outreach-setup': 'Konfiguracja Kampanii',
  'guest-messaging.reservations': 'Rezerwacje',
  'guest-messaging.insights_logs': 'Statystyki i Logi',

  'guest-messaging.settings.placeholder':
    'Skonfiguruj preferencje komunikacji z gośćmi.',
  'guest-messaging.outreach.placeholder':
    'Skonfiguruj kampanie i szablony komunikacji.',
  'guest-messaging.reservations.placeholder':
    'Zarządzaj komunikacją dotyczącą rezerwacji.',
  'guest-messaging.placeholder': 'Moduł komunikacji z gośćmi wkrótce dostępny.',

  'guest-messaging.reservation-source': 'Źródło Danych Rezerwacji',
  'guest-messaging.communication-channels': 'Kanały Komunikacji',
  'guest-messaging.templates': 'Szablony',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Profil Firmy',
  'guest-messaging.work-orders': 'Zlecenia Pracy',

  'guest-messaging.work-orders.placeholder':
    'Zarządzaj zleceniami pracy związanymi z komunikacją z gośćmi.',

  'dashboards.tickets-by-category': 'Zgłoszenia według Kategorii',
  'dashboards.download': 'Pobierz',
  'dashboards.space-booking': 'Rezerwacja Przestrzeni',
  'dashboards.gift-voucher': 'Vouchery Podarunkowe',
  'dashboards.chatbots': 'Chatboty',
  'dashboards.form': 'Od',
  'dashboards.to': 'Do',

  'dashboards.active-groups': 'Aktywne Grupy',
  'dashboards.active-properties': 'Aktywne Obiekty',
  'dashboards.live-properties': 'Aktywne Obiekty Online',
  'dashboards.properties-going': 'Obiekty uruchamiane według zakresu dat',

  'dashboards.start-date': 'Data Początkowa',
  'dashboards.end-date': 'Data Końcowa',

  'dashboards.all-properties-with': 'Wszystkie obiekty ze statusem aktywnym',

  'dashboards.aibot-by-country': 'Klienci Chatbota AI według Kraju',

  'dashboards.list-live-clients':
    'Lista aktywnych klientów korzystających z Chatbota AI',

  'dashboards.subscribe-to-reports': 'Subskrybuj Raporty',

  'dashboards.website-visits': 'Wizyty na Stronie',
  'dashboards.unique-visitors': 'Unikalni Odwiedzający',
  'dashboards.last-week': 'Ostatni Tydzień',
  'dashboards.this-week': 'Ten Tydzień',
  'dashboards.this-month': 'Ten Miesiąc',
  'dashboards.previous-month': 'Poprzedni Miesiąc',
  'dashboards.yeartodate': 'Od Początku Roku',
  'dashboards.lastyear': 'Ostatni Rok',
  'dashboards.last-7-days': 'Ostatnie 7 Dni',
  'dashboards.last-30-days': 'Ostatnie 30 Dni',
  'dashboards.last-60-days': 'Ostatnie 60 Dni',
  'dashboards.last-90-days': 'Ostatnie 90 Dni',

  'dashboards.conversion-rates': 'Współczynniki Konwersji',
  'dashboards.digital-assistant-engagement':
    'Zaangażowanie Cyfrowego Asystenta',

  'dashboards.total-overnight-conversations':
    'Łączna Liczba Rozmów i Rozmów Nocnych (19:00–7:00)',

  'dashboards.percentage-accuracy': 'Pokrycie Wiedzy',
  'dashboards.percentage-conversion': 'Konwersja Ruchu Strony na Czat',

  'dashboards.percentage-avatarclick':
    'Konwersja Ruchu Strony na Kliknięcia Awatara',

  'dashboards.percentage-negativefeedback':
    'Negatywne Opinie jako % Kliknięć Awatara',

  'dashboards.percentage-amenties': 'Zapytania o Udogodnienia',
  'dashboards.percentage-booking': 'Zapytania o Rezerwacje',
  'dashboards.percentage-webchats': 'Czaty na Stronie',
  'dashboards.percentage-facebookchat': 'Czaty na Facebooku',

  'dashboards.number-webchattime': 'Łączny Czas Rozmów',
  'dashboards.number-totalconversation': 'Łączna Liczba Rozmów',
  'dashboards.number-averagetimeconversation': 'Średni Czas Rozmowy',

  'dashboards.number-websiteconversation': 'Rozmowy na Stronie',

  'dashboards.number-facebookconversation': 'Rozmowy na Facebooku',

  'dashboards.number-estimatedtimesaving': 'Szacowana Oszczędność Czasu',

  'dashboards.number-googlemapsconversation': 'Rozmowy przez Google Maps',

  'dashboards.number-whatsappconversation': 'Rozmowy WhatsApp',

  'dashboards.number-instagramconversation': 'Rozmowy Instagram',

  'dashboards.number-agentconversation': 'Rozmowy z Agentem',

  'dashboards.number-amenityqueries': 'Zapytania o Udogodnienia',

  'dashboards.number-bookingenquiries': 'Zapytania o Rezerwacje',

  'dashboards.number-groupbookingenquiries': 'Zapytania o Rezerwacje Grupowe',

  'dashboards.number-eventenquiries': 'Zapytania o Wydarzenia',

  'dashboards.number-longstayenquiries': 'Zapytania o Długie Pobyty',

  'dashboards.number-totaltickets': 'Zgłoszenia',
  'dashboards.number-returncustomer': 'Powracający Klient',
  'dashboards.number-redirects': 'Przekierowania Strony',
  'dashboards.number-bookingengineleads': 'Leady z Silnika Rezerwacji',

  'dashboards.number-roomnightsreferred': 'Polecone Noclegi',

  'dashboards.number-revenuereferred': 'Polecony Przychód',
  'menu.bookingsmenu': 'Rezerwacje',
  'menu.guests': 'Informacje o Gościach',
  'menu.whatsnew': 'Co nowego',

  'menu.formbuilder': 'Kreator Formularzy',
  'forms.forms-title': 'Formularz',

  'dashboards.trainAI': 'Trenuj AI za pomocą dokumentów',

  'dashboards.uploadDocuments':
    'Prześlij dokumenty, aby pomóc AI nauczyć się informacji o Twojej firmie i wspierać klientów tak jak Ty. Możesz dodawać pliki .doc, .pdf lub .txt.',

  'dashboards.welcomeMessage': 'Wiadomość Powitalna',

  'dashboards.personalizeGreeting':
    'Spersonalizuj sposób powitania klientów, aby odzwierciedlał Twoją markę, styl i etykietę, zapewniając jak najcieplejsze przyjęcie. Dostosuj powitania, aby odzwierciedlały Twoją markę i stworzyły przyjazną atmosferę.',

  'dashboards.addRoomDetails':
    'Dodaj szczegóły dotyczące każdego pokoju, aby goście mogli łatwo znaleźć wszystko, czego potrzebują do wyboru idealnej opcji oraz uprościć i przyspieszyć proces rezerwacji.',

  'dashboards.trainAIFAQs': 'Trenuj AI za pomocą FAQ',

  'dashboards.manualQuestions':
    'Na niektóre pytania nie można odpowiedzieć na podstawie dokumentów ani treści strony internetowej. Tutaj możesz ręcznie dodawać pytania, aby klienci zawsze mieli potrzebne informacje pod ręką.',

  'dashboards.publishAI':
    'Publikuj AI, aby odzwierciedlało najnowsze aktualizacje',

  'dashboards.retrainAfterChanges':
    'Po wprowadzeniu zmian w Bazie Wiedzy lub formularzach pamiętaj o ponownym przeszkoleniu chatbota na zaktualizowanych informacjach. Publikacja AI zapewnia najbardziej dokładne i aktualne odpowiedzi.',

  'dashboards.enhanceKnowledge':
    'Rozszerz wiedzę AI poprzez śledzenie pytań bez odpowiedzi',

  'dashboards.reviewUnanswered':
    'Za każdym razem, gdy AI nie może odpowiedzieć na pytanie lub podaje ograniczone informacje, znajdziesz te zapytania tutaj. Przejrzyj je, aby zidentyfikować luki w Bazie Wiedzy lub unikalne pytania gości.',

  'dashboards.manageMedia': 'Zarządzaj Mediami',

  'dashboards.mediaGallery':
    'Za każdym razem, gdy przesyłasz obrazy, takie jak pokoje, udogodnienia, logotypy lub cyfrowy awatar, pojawią się one w tej galerii, zapewniając centralne miejsce do zarządzania wizualizacjami i prezentowania wyjątkowości Twojej firmy.',

  'dashboards.createForms':
    'Twórz formularze łatwo i otrzymuj powiadomienia o każdym przesłaniu.',

  'dashboards.manageForms':
    'Twórz i zarządzaj formularzami do zbierania informacji od klientów, konfiguruj powiadomienia i dostosowuj je do różnych języków.',

  'dashboards.personalizeResponse':
    'Personalizuj styl odpowiedzi i przebieg rozmowy',

  'dashboards.controlConversation':
    'Ta zaawansowana funkcja umożliwia kształtowanie i kontrolowanie przebiegu rozmów z klientami w różnych kanałach.',

  'menu.virtualfrontdesk': 'Wirtualna Recepcja',
  'menu.guestservice': 'Usługi dla Gości',

  'virtual-front.common-questions': 'Najczęściej Zadawane Pytania',
  'virtual-front.add-on-upsells': 'Dodatki i Upselling',
  'virtual-front.service-order': 'Zamówienia Usług',

  // 'virtual-front.guest-service-add-on-upsells': "Usługi dla Gości i Dodatki",
  'virtual-front.guest-service-add-on-upsells': 'Cyfrowe Kompendium',

  'virtual-front.outbound': 'Wychodzące',
  'virtual-messenger': 'Menu Widżetu Webowego',

  'missed-response.missed-response-title': 'Tytuł Pominiętej Odpowiedzi',

  // unified-inbox
  'content.allconversation': 'Wszystkie Rozmowy',
  'content.active': 'Aktywne',
  'content.tickets': 'Zgłoszenia',
  'content.filter': 'Filtr',
  'content.createtickets': 'Utwórz Zgłoszenie',
  'content.conversation': 'Rozmowa',
  'content.knowledgesearch': 'Wyszukiwanie w Bazie Wiedzy',
  'content.reply': 'Odpowiedz',
  'content.visitorinfo': 'Informacje o Odwiedzającym',
  'content.callinfo': 'Informacje o Połączeniu',
  'content.allinsights': 'Wszystkie Statystyki',
  'content.availabilityrates': 'Dostępność i Stawki',
  'content.callback': 'Oddzwoń',
  'content.close': 'Zamknij',
  'content.sms': 'SMS',
  'content.timestamp': 'Znacznik Czasu',
  'content.topics': 'Tematy',
  'content.callingparty': 'Strona Dzwoniąca',
  'content.accountdomain': 'Domena Konta',
  'content.calledparty': 'Strona Odbierająca',
  'content.recording': 'Nagranie',

  'content.phonesystemoriginationcallid':
    'ID Połączenia Początkowego Systemu Telefonicznego',

  'content.phonesystemterminationcallid':
    'ID Połączenia Końcowego Systemu Telefonicznego',

  'content.uniqueconversationid': 'Unikalny ID Rozmowy',

  'content.regenerateinsights': 'Wygeneruj Statystyki Ponownie',

  'content.customersentiment': 'Nastawienie Klienta',

  'content.neutral': 'Neutralne',

  'content.conversationinsights': 'Statystyki Rozmowy',

  'content.customeridverification': 'Weryfikacja ID Klienta',

  'content.serviceactivationdate': 'Data Aktywacji Usługi',

  'content.followups': 'Działania Następcze',

  'content.actionneeded': 'Wymagane działanie',

  'content.uniqueConversationId': 'Unikalny ID Rozmowy',

  'content.uniqueChatId': 'Unikalny ID Czatu',

  'content.recording&transcript': 'Nagranie i Transkrypcja',

  'content.chatinsights': 'Statystyki Czatu',
  'content.visitedpages': 'Odwiedzone Strony',
  'content.deviceinfo': 'Informacje o Urządzeniu',

  'content.chatstartedonthispage': 'Czat rozpoczął się na tej stronie',

  'content.prechatinfo': 'Informacje Przed Czatem',
  'content.notes': 'Notatki',
  'content.reassign': 'Przypisz Ponownie',
  'content.open': 'Otwórz',
  'content.dismiss': 'Odrzuć',

  'content.add_placeholder': 'Dodaj wartości zastępcze',

  'content.mobile_number': 'Numer Telefonu Komórkowego',

  'content.please_select': 'Proszę Wybrać',

  'content.sendwhatsapp': 'Wyślij Wiadomość WhatsApp',

  /* Missed-response */
  'feedback.missed-question': 'Pominięte Pytanie',

  'feedback.conversation-summary': 'Podsumowanie Rozmowy',

  'feedback.dates-in-spanish': 'Daty muszą być w języku hiszpańskim',

  'feedback.resolve': 'Rozwiąż',
  'feedback.ignore': 'Ignoruj',

  // integration
  'integration.select_properties': 'Wybierz Obiekty',

  'integration.select_properties_enabled':
    'Wybierz obiekty aktywowane przez tę integrację',

  'integration.services_addons': 'Wybierz Usługi i Dodatki',

  'integration.services_visible':
    'Wybierz usługi i dodatki widoczne na tej stronie',

  'integration.appearance': 'Wygląd',

  'integration.appearance_customize':
    'Wybierz nazwę cyfrowego asystenta, awatar i skonfiguruj kolory',

  'integration.booking_calendar': 'Kalendarz Rezerwacji',

  'integration.booking_calendar_style':
    'Wybierz styl wyskakującego kalendarza rezerwacji',

  'integration.nudges': 'Podpowiedzi',

  'integration.nudges_setup':
    'Skonfiguruj proaktywne wiadomości angażujące odwiedzających stronę',

  'integration.position': 'Pozycja',

  'integration.position_control':
    'Kontroluj pozycję widżetu czatu na swojej stronie',

  'integration.custom_fonts': 'Niestandardowe Czcionki',

  'integration.custom_fonts_upload':
    'Prześlij niestandardowe czcionki, których chcesz używać na stronie',

  'integration.custom_css': 'Niestandardowy CSS',

  'integration.custom_css_usage': 'Użyj CSS, aby dostosować Cyfrowe Kompendium',

  'integration.location': 'Lokalizacja',

  'integration.location_embed': 'Dodaj URL lokalizacji do osadzenia',

  'integration.external_links': 'Linki Zewnętrzne',

  'integration.external_links_add': 'Dodaj swoje linki',

  'integration.language': 'Język',

  'integration.widget_languages': 'Wybierz języki dla widżetu czatu',

  'integration.chatbot_contact': 'Chatbot',

  'integration.chatbot_enable': 'Włącz swojego cyfrowego asystenta',

  'integration.chatbot_security': 'Zabezpiecz swój Messenger',

  'integration.chatbot_trusted_pages':
    'Dodaj zaufane strony do wyświetlania Chatbota',

  'integration.chatbot_publish': 'Opublikuj swojego cyfrowego asystenta',

  'integration.chatbot_install':
    'Skopiuj fragment kodu, aby zainstalować cyfrowego asystenta',

  'integration.google_analytics': 'Śledzenie Google Analytics',

  'integration.google_analytics_desc':
    'Śledź aktywność użytkowników, sesje i kluczowe działania w widżecie webowym przy użyciu GA4.',

  'integration.enable_ga4': 'Włącz Google Analytics',

  'integration.ga4_measurement_id': 'Identyfikator pomiaru GA4',

  'integration.ga4_id_example': 'Przykład: G-ABCD123456',

  'integration.track_events': 'Śledź zdarzenia',

  'integration.track_events_desc':
    'Wybierz działania użytkownika, które mają być wysyłane jako zdarzenia GA4.',

  'integration.avatar_click': 'Kliknięcie awatara',

  'integration.avatar_click_desc':
    'Śledź, gdy użytkownik kliknie awatar czatu.',

  'integration.menu_click': 'Kliknięcie menu',

  'integration.menu_click_desc':
    'Śledź, gdy użytkownik otworzy menu widżetu webowego.',

  'integration.chat_started': 'Rozpoczęto czat',

  'integration.chat_started_desc':
    'Śledź pierwszą wiadomość użytkownika raz na sesję.',

  'integration.event_tag': 'Tag zdarzenia',

  'integration.event_prefix': 'Prefiks zdarzenia',

  'integration.final_tag': 'Tag końcowy',

  'integration.example_event': 'Przykładowe zdarzenie',

  'integration.once_per_session': 'Tylko raz na sesję',

  'integration.saving': 'Zapisywanie...',

  'integration.save_ga4_settings': 'Zapisz ustawienia GA4',
};

export default plMessages;
